import { balanceModel } from '@models/balance.model';
import { useSuiClient } from '@mysten/dapp-kit';
import { useModel } from 'foca';
import { useEffect } from 'react';
import { useAddress } from './use-address';
import { useRefreshTime } from './use-refresh';

export const useInitBalances = () => {
  const { refreshTime } = useRefreshTime();
  const client = useSuiClient();
  const address = useAddress();
  const balances = useModel(balanceModel, (state) => state.balances[address || '']);
  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    const loop = () => {
      address && balanceModel.getBalances(address, client);

      timer = setTimeout(() => {
        loop();
      }, 30_000);
    };
    loop();
    return () => {
      clearTimeout(timer);
    };
  }, [address, refreshTime, client]);

  return { balances: balances || [] };
};

export const useBalances = () => {
  const address = useAddress();
  const balances = useModel(balanceModel, (state) => state.balances[address || '']);
  return { balances: balances || [] };
};

export const useBalance = (coinType: string | undefined) => {
  const address = useAddress();
  const balances = useModel(balanceModel, (state) => state.balances[address || '']);
  return {
    balance: balances?.find((balance) => balance.coinType === coinType)?.totalBalance || '0',
  };
};
